export default {
  org: lang.templateByUuid("UID:P_UDHWN_17DD50DE050006D9","组织") /* "组织" */
};
